<template>
    <div class="projectList">
        <leftnav class="fl" :mkcode="yj_mkcode" :itemcode="yj_itemcode" docutitle="已录入项目"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <div class="index_left_centerpage">
                <div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
                        <span class="current title">已录入项目<em>({{ total }})</em></span>
                        <div class="fl search-box nz-search-box">
							<span class="searchtype">项目名称</span>
							<input type="text" placeholder="请输入关键词" class="search-input" v-model="kw"/>
							<button class="search-btn" @click="getProjectList(1)">查询</button>
						</div>
                    </div>
                </div>
                <div class="enterprise_list_box whitebox">
                    <div class="enterparise_guide oh" style="width: 95%; ">
                        <p class="fl">为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
                    </div>
                    <div class="oh">
                        <el-button type="primary" :loading="downloadLoading" class="export_btn"
                            @click="downloadFun">导出数据</el-button>
                    </div>
                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
                        <tr>
                            <th>项目名称</th>
                            <th>企业名称</th>
                            <th>产业类型</th>
                            <th>项目类型</th>
                            <th>项目状态</th>
                            <th>投资额(亿元)</th>
                            <th>年产值(亿元)</th>
                            <th>简介</th>
                            <th>操作</th>
                        </tr>
                        <tr v-for="item in enterpristlist" :key="item.stockcode">
                            <td @click="detailrouterto('/workbenchEnterpriseDetails', item.id)" v-if="item.id != ''"
                                :class="item.id != '' ? 'title' : ''">{{ item.project || '-' }}</td>
                            <td @click="detailrouterto('/workbenchEnterpriseDetails', item.id)" v-if="item.id != ''"
                                :class="item.id != '' ? 'title' : ''">{{ item.customerName || '-' }}</td>
                            <td>{{ item.smallClassText || '-' }}</td>
                            <td>{{ item.projectTypeText || '-' }}</td>
                            <td>{{ item.statusText || '-' }}</td>
                            <td>{{ item.amount || '-' }}</td>
                            <td>{{ item.outputValue || '-' }}</td>
                            <td @click="SummaryDaialogText = item.summary; isSummaryDaialog = true"
                                :class="{ 'cur-pointer': true, 'bluefont': item.summary != '', 'summary-td': true }">{{
                                item.summary || '-' }}</td>
                            <td class="cur-pointer basefont" v-show="item.delete" @click="deleteCustomer(item)">删除 >
                            </td>
                            <td class="cur-pointer basefont" v-show="!item.delete"
                                @click="detailrouterto('/workbenchEnterpriseDetails', item.id)">查看 ></td>
                        </tr>
                    </table>
                </div>

                <el-dialog class="localChain" custom-class="initiate_box_dialog" title="项目简介" center width="850px"
                    :visible.sync="isSummaryDaialog" top="25vh">
                    <div>{{ SummaryDaialogText }}</div>
                </el-dialog>
                <div class="centerpage1 company_pagelist" v-show="totalPage > 1">
                    <zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
                        v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: "projectList",
    data() {
        return {
            currentTab: '5',
            userdata: {},
            yj_mkcode: 'E',
            yj_itemcode: 'E-ylrxm',
            enterpristlist: [],
            page: 1, //显示的是哪一页
            haspage: true, //是否还有下一页
            pageSize: 10, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数 
            isSummaryDaialog: false,
            SummaryDaialogText: '',
            downloadLoading: false,
            kw: '',
        }
    },
    computed: {
        ...mapState({ isCollapse: (state) => state.isCollapse, }),
        ...mapGetters(['isCollapse'])
    },

    components: {
    },
    created() {
        this.userdata = this.getuseriformation();
    },
    mounted() {
        this.getProjectList();
    },

    methods: {
        //删除项目
        deleteCustomer(item) { //删除企业提示
            let taht = this;
			this.$confirm('此操作将删除该企业, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.deleteProject(item);
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
        },
        deleteProject(item) { 
            let _this = this;
            let ajaxurl = this.$api.crm.customer.delete() ;
            $.ajax({
				type: "POST",
				url: ajaxurl,
				data: {
					id: item.id
				},
				headers: {
					AuthToken: this.userdata.token
				},
				success: function (res) {
					console.log('11', res);
					if (res.success) { 
                        _this.getProjectList();
					}
					var successtype = res.success ? 'success' : "info";
					var successtext = res.success ? '删除成功' : res.msg;
					_this.$message({ type: successtype, message: successtext, });

				}
			})
        },
        downloadFun() {
            this.downloadLoading = true;
            let ajaxurl = this.$api.crm.project.Export();
            var fileName = '导出项目信息' + Date.now() + '.xlsx';
            try {
                //1请求后台获取文档流
                this.$axios.get(ajaxurl, { headers: { AuthToken: this.userdata.token },responseType: 'blob' }).then((res) => {
                    console.log('下载后台返回的文档流', res.data);
                    // const blob = res;
                    const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                    //2 创建一个url 对象，并将blob实例作为参数传入，这样href的值就是以blob开头的一个文件流下载链接
                    const url = window.URL.createObjectURL(blob);
                    //3创建下载链接
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName || Date.now();
                    a.style.display = 'none';
                    a.click();
                    //4避免占用销毁创建的链接
                    document.body.removeChild(a)

                }).catch(function (error) {
                    // 请求失败处理 console.log(error);
                });
            } catch (error) {
                console.error('导出文件异常Error:', error);
            } finally {
                this.downloadLoading = false;
            }
        },
        //详情页跳转
        detailrouterto(path, id) {
            if (id == 0 || id == "") {
                return;
            }
            this.routerlinkarry(path, { id: id });
        },
        getProjectList(page) {
           this.page = page || 1;
            // 获取项目列表
            this.bus.$emit('loading', true);
            var _this = this;
            let ajaxurl1 = this.$api.crm.project.list() + '?page=' + this.page+'&kw='+this.kw + '&pageSize=' + this.pageSize;
            this.$axios.get(ajaxurl1, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {

                console.log("项目列表", res.data);
                if (res.data.success) {
                    _this.enterpristlist = res.data.list;
                    _this.pageSize = res.data.pageSize//每一页显示的数据条数
                    _this.total = res.data.totalRecord//每一页显示的数据条数
                    _this.totalPage = res.data.totalPage//每一页显示的数据条数

                } else {
                    _this.$message.error(res.data.msg);
                }
                _this.bus.$emit('loading', false);

            }).catch(function (err) {
                console.log(err);
            });
        },
        pageHandler: function (page) {
            this.getProjectList(page);
        },
        searchenter(e) {
				if (e.keyCode == 13) {
					this.getProjectList();
				}
			},
    }
}
</script>

<style scoped lang="scss">
.export_btn {
    float: right;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 50px;
}

::v-deep {
    .el-dialog__body {
        font-size: 16px;
    }
}

.enterprise_list_box {
    min-height: 75vh;
}

.summary-td {
    // width: 100%;
    height: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: 1; //行数
    line-clamp: 1;
    -webkit-box-orient: vertical; //盒子中内容竖直排列 
    line-height: 70px;
}
</style>